import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';

import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import Link from 'shared/components/Link';
import { EVENTS } from 'shared/constants/gtmEvents';
import { setDataLayer } from 'shared/actions/globals';
import withPixelRatio from 'shared/hocs/withPixelRatio';
import StoAwards from 'shared/components/StoAwards/StoAwards';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import withStatsEvents from 'shared/hocs/stats/withStatsEvents';
import { AutobookingForm } from 'shared/components/AutobookingForm';
import DealerWebsiteLink from 'shared/components/DealerWebsiteLink/DealerWebsiteLink';

import s from './LegacyDealerItem.css';

const isMobile = __APP__ === 'mobile';

// TODO: Need refactrotoring to use with firms only, no Dealers.
// For Dealers should be DealerItems only.
class LegacyDealerItem extends React.Component {
  static propTypes = {
    dealer: PropTypes.shape({}).isRequired,
    events: PropTypes.shape({}).isRequired,
    setRatioImage: PropTypes.func.isRequired,
    type: PropTypes.string,
    url: PropTypes.string,
    //
    intl: intlShape.isRequired,
    setDataLayer: PropTypes.func.isRequired,
  };

  static defaultProps = {
    type: 'dealer',
    url: null,
  };

  state = { isShowedPhones: false };

  handleShowPhonesClick = () => {
    const { dealer: { id }, events } = this.props;
    events.dispatchDealerShowPhoneEvent(id);
    this.setState({ isShowedPhones: true });
  };

  handleAllAdvertsClick = () => {
    this.props.setDataLayer(EVENTS.showAllDealerAdverts);
  };

  render() {
    const { dealer, type, url: urlPrefix, setRatioImage, intl } = this.props;
    const url = urlPrefix ? `${urlPrefix}${dealer.slug}/` : `/avtosalony/${dealer.slug}/`;
    const {
      title,
      tags: dealerTags,
      logo,
      address,
      website,
      phones,
      adverts_count: advertsCount = intl.formatMessage({ id: 'Нет' }),
      is_official: isOfficial = false,
      test_drive: testDrive = false,
      trade_in: tradeIn = false,
      accessories = false,
      insurance = false,
      credit = false,
      awards,
    } = dealer;

    const { isShowedPhones } = this.state;

    const tags = [
      testDrive && {
        title: intl.formatMessage({ id: 'Тест-драйв' }),
      },
      tradeIn && {
        title: 'Trade-in',
      },
      // accessories && {
      //   title: intl.formatMessage({ id: 'Аксессуары' }),
      // },
      // insurance && {
      //   title: intl.formatMessage({ id: 'Cтрахование' }),
      // },
      // credit && {
      //   title: intl.formatMessage({ id: 'Кредитование' }),
      // },
    ].filter(i => !!i);

    const IMAGE_WIDTH = 100;

    const logoImg = logo && setRatioImage(logo.replace('http:', 'https:'), IMAGE_WIDTH);
    const isFirm = type === 'firm';
    const elemStyles = isFirm
      ? {
          minHeight: '120px',
        }
      : null;
    const shouldShowOffers =
      !isFirm || dealerTags.find(item => item.slug === 'zapchasti' || item.slug === 'avtorazborka');

    return (
      <div
        className={cx(s.root, {
          [s.isMobile]: isMobile,
        })}
        style={elemStyles}
      >
        <div className={s.left}>
          <div className={s.logo}>
            <Link to={url}>
              <img className={s.img} src={logoImg} width={IMAGE_WIDTH} alt="" />
            </Link>
          </div>
        </div>
        <div className={s.right}>
          <div className={s.title}>
            <Link className={s.link} to={url}>
              {title}
            </Link>
            {awards &&
              !!awards.length &&
              <StoAwards awards={awards} customStyle={s.awardsSection} />}
          </div>
          {isOfficial &&
            <div className={s.isOfficial}>
              <FormattedMessage id="Официальный дилер" />
            </div>}
          {tags &&
            !isFirm &&
            <div className={s.tags}>
              {tags.map(item =>
                <div className={s.tag} key={item.title}>
                  {item.title}
                </div>,
              )}
            </div>}
          <div className={s.adr}>
            {address}
          </div>
          <div className={s.photos}>
            {dealer.photos &&
              dealer.photos
                .slice(0, 5)
                .map(item =>
                  <img
                    src={item.image && setRatioImage(item.image.replace('http:', 'https:'), 60)}
                    key={item.id}
                    width="60"
                    alt=""
                  />,
                )}
          </div>
          {shouldShowOffers &&
            <div className={s.adverts}>
              <Link onClick={this.handleAllAdvertsClick} to={url} className={s.allAdvertsLink}>
                {advertsCount} <FormattedMessage id="предложений" />
              </Link>
            </div>}
        </div>
        <div className={s.actions}>
          {isShowedPhones
            ? <div className={s.phones}>
                {phones.map(({ id, number }) =>
                  <div key={id}>
                    {number}
                  </div>,
                )}
                {!phones.length > 0 && <FormattedMessage id="Нет телефонов" />}
              </div>
            : <button className={s.btn} onClick={this.handleShowPhonesClick}>
                <FormattedMessage id="Показать телефон" />
              </button>}
          <AutobookingForm className={s.btn} advert={dealer} />
          {website &&
            <DealerWebsiteLink dealer={dealer} ClassName={s.btn}>
              <FormattedMessage id="Перейти на сайт" />
            </DealerWebsiteLink>}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(
  connect(null, { setDataLayer })(injectIntl(withStatsEvents(withPixelRatio(LegacyDealerItem)))),
);



// WEBPACK FOOTER //
// ./src/desktop/components/DealerItem/LegacyDealerItem.js